import { RouteObject } from 'react-router-dom';
import { BrowserPage } from './pages/browser';
import { EntityViewPage } from './pages/entity-view';
import Authorizer from './components/authorizer';
import { Header } from './components/header';

const DfcRoutes: RouteObject[] = [
  {
    element: (
      <div className='font-sans font-[450]'>
        {/* TODO: This is temporary. */}
        <Header />
        <Authorizer />
      </div>
    ),
    children: [
      {
        path: '/portal/dfc/browser',
        element: <BrowserPage />
      },
      {
        path: '/portal/dfc/browser/:entityId',
        element: <BrowserPage />
      },
      {
        path: '/portal/dfc/view/:entityId',
        element: <EntityViewPage />
      }
    ]
  }
];

export default DfcRoutes;
